async function sha256(str) {
    if (!crypto?.subtle)
        return 'insecure_env_user';
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
    return [...new Uint8Array(buf)].map(x => (('00' + x.toString(16)).slice(-2))).join('');
}
export async function addPendo(pendoData) {
    const { productIdentifier, production, apiKey, userData } = pendoData;
    const { email, role, fullName, crm, companyName, accountType, ecoIdClient, language } = userData;
    if (!apiKey)
        return;
    const envSuffix = production ? '' : '_test';
    const userId = email
        ? `${await sha256(email)}${envSuffix}`
        : `login_${productIdentifier}${ecoIdClient ? `_${ecoIdClient}` : ''}${envSuffix}`;
    const emailDomain = email?.split('@')?.[1];
    const isInternalUser = !!email?.match(/ecoonline.com/g);
    const hasNoCrm = typeof crm === 'undefined' || crm === null;
    const hasGenericCrm = `${crm}` === '0';
    const accountId = hasNoCrm
        ? 'none'
        : (hasGenericCrm ? `${productIdentifier}_${crm}${envSuffix}` : `${crm}${envSuffix}`);
    const userInfo = {
        visitor: {
            id: userId,
            domain: emailDomain,
            [`role_${productIdentifier}`]: role,
            email: isInternalUser ? email : undefined,
            full_name: isInternalUser ? fullName : undefined,
            user_language: language
        },
        account: {
            id: accountId,
            name: companyName,
            crm: (hasNoCrm || hasGenericCrm) ? undefined : crm,
            type: accountType
        }
    };
    (function (key) {
        // @ts-ignore
        (function (p, e, n, d, o) { var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || []; v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)
            (function (m) { o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); }; })(v[w]); y = e.createElement(n); y.async = !0; y.src = 'https://cdn.eu.pendo.io/agent/static/' + key + '/pendo.js'; z = e.getElementsByTagName(n)[0]; z.parentNode?.insertBefore(y, z); })(window, document, 'script', 'pendo');
        pendo.initialize(userInfo);
    })(apiKey);
}
